import classNames from 'classnames';
import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import ProgressBarSkeleton from './ProgressBarSkeleton';
import { ProgressBarProps } from './types';

import './ProgressBar.scss';

const ProgressBar: React.FC<ProgressBarProps> = ({
    value,
    max,
    label,
    size = 'standard',
    variant = 'standard',
    show = true,
    wrapperClassName,
    className,
    isWarning = false,
    isDanger = false,
    isLoading = false,
    labelSkeleton = <DarkSkeleton height={16} width={170} />,
    maxWidth = 'unset',
}) => {
    if (isLoading)
        return (
            <ProgressBarSkeleton
                labelSkeleton={labelSkeleton}
                wrapperClassName={wrapperClassName}
                className={className}
                size={size}
                variant={variant}
            />
        );
    if (!show) return null;
    return (
        <section
            className={classNames('progress-bar__wrapper', wrapperClassName)}
            style={{ '--progress-bar-max-width': maxWidth } as React.CSSProperties}
        >
            <div className="progress-bar__label-wrapper">{label}</div>
            <progress
                className={classNames(
                    'progress-bar__element',
                    className,
                    {
                        danger: isDanger,
                        warning: isWarning,
                    },
                    size,
                    variant,
                )}
                max={max}
                value={value}
            />
        </section>
    );
};

export default ProgressBar;
